<style lang="less" scoped>
@import '../../../style/common/variable';
ul {list-style: none;margin: 0px;padding: 0px;}
.hotnews {width: 340px;height: 610px;display: flex;flex-direction:column;   justify-content:space-between;
  .headlines {cursor: pointer;
    .icon {width: 58px;height: 24px;border-radius: 13px;display: flex;}
    .tit {width: 100%;height: 44px;font-family: Source Han Sans CN;font-size: 17px;font-weight: normal;font-stretch: normal;letter-spacing: 1px;color: #333333;margin: 10px 0px;overflow: hidden;overflow:hidden;display:table-cell;
    vertical-align:bottom;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
}
    .thumb {width: 333px;height: 192px;background-color: #ffffff;border-radius: 8px;}
  }
  .latest {overflow: hidden;
    .tool {display: flex;justify-content:space-between; align-items: center;
      .new {font-family: Alibaba-PuHuiTi-R;font-size: 20px;font-weight: normal;font-stretch: normal;line-height: 35px;letter-spacing: 1px;color: #08032b;}
      .more {font-family: Microsoft YaHei;font-size: 14px;font-weight: normal;font-stretch: normal;line-height: 19px;letter-spacing: 1px;color: #666666;cursor: pointer;}
    }
    ul {overflow: hidden;
      li {width: 100%;margin-top: -10px;cursor: pointer;
        .time {display: flex;width: 100%;font-family: Microsoft YaHei;font-size: 14px;font-weight: normal;font-stretch: normal;letter-spacing: 1px;color: #666666;}
        .text {width: 100%;height: 37px;font-family: Source Han Sans CN;font-size: 13px;font-weight: normal;font-stretch: normal;letter-spacing: 1px;color: #999999;margin: -6px 0px;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;overflow:hidden;-webkit-box-orient: vertical;text-align: left;}
        .title {width: 100%;height:20px;font-family: Microsoft YaHei;font-size: 16px;font-weight: normal;font-stretch: normal;letter-spacing: 1px;color: #444546;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;text-align: left;margin-top: 14px;}
      }
    }
  }
}
@media screen and (max-width: @max-screen){
  .hotnews .headlines .thumb{width: 77vw; }
}
</style>

<template>
  <div class="hotnews">
    <div class="headlines" @click="clickHotNews(headlines[0])">
      <!-- <img class="icon" src="static/index/image_tt.png" alt=""> -->
      <img class="icon" src="../../../../static/images/官网首页/image_tt.png" alt="">
       <p class="tit">{{headlines[0] && headlines[0].title }}</p>
      <img class="thumb" :src="(headlines[0] && headlines[0].pic) || ''" />
    </div>
    <div class="latest">
      <div class="tool">
        <span class="new">最新</span>
        <span class="more" @click="goMore">更多 >></span>
      </div>
      <ul>
        <li v-for="(item, index) in hotNewslist" :key="index"  @click="clickHotNews(item)">
          <!-- <span class="time">{{item.time * 1000 | formatDate()}}</span> -->
          <p class="title"> {{ item.title }} </p>
          <span class="text">{{ item.text }} </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import filters from '../method/filter.js'
export default {
  props: ['headlines', 'hotNewslist'],
  mixins: [filters],
  data()
  {
    return {
    }
  },
  // created()
  // {
  //   console.log(this.Headlines)
  //   console.log(this.HotNewslist)
  // },
  methods: {
    // 点击 新闻的 标题或者内容，将 整个news对象传递给父组件
    clickHotNews(item)
    {
      this.$emit('clickHotNews', item)
    },
    goMore()
    {
      let url = this.$router.resolve({path: '/KyzxIndex'})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/NewHotNews.vue